<template>
  <div class="focus-view">
    <div class="tabs-mask">
      <div
        v-for="(item, index) in tabs"
        :key="index"
        class="tab-item"
        :class="{ 'checked-tab': index === checkedTabIndex }"
        @click="checkTab(index)"
      >
        {{ langTransfer(item.text) }}
      </div>
    </div>
    <bscroll-view>
      <div class="main-content">
        <div class="list-mask">
          <div v-if="checkedTabIndex === 0" class="result-list">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="magazine-item"
              @click="
                detailDispatcher(
                  'magazine',
                  item,
                  3
                )
              "
            >
              <div class="hb-resource-cover lr-img-scale">
                <img v-if="item.author_poster" :src="item.author_poster" />
              </div>
              <p class="text1line">
                {{ langTransfer(item.author_name) }}
              </p>
            </div>
          </div>
          <div v-if="checkedTabIndex === 1" class="result-list">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="article-item lr-img-scale"
              @click="routerPush(item)"
            >
              <div class="hb-resource-cover">
                <img v-if="item.author_poster" :src="item.author_poster" />
              </div>
              <p class="text1line">
                {{ langTransfer(item.author_name) }}
              </p>
            </div>
          </div>
        </div>
        <div class="action-warning-wrap">
          <button
            v-show="list.length > 0 && !getAll"
            class="common-read-more lr-img-scale"
            @click="loadMore"
          >
            {{ langTransfer("加载更多") }}
          </button>
          <div v-show="list.length > 0 && getAll" class="has-no-more">
            {{ langTransfer("- 没有更多了 -") }}
          </div>
        </div>
      </div>
    </bscroll-view>
  </div>
</template>

<script>
import BscrollView from "@/components/bscrollView";
import { focusList } from "@/api/hb";

export default {
  name: "Focus",
  components: {
    BscrollView,
  },
  data() {
    return {
      checkedTabIndex: 0,
      tabs: [
        {
          text: "期刊",
          type: 5,
        },
        {
          text: "知识库",
          type: 3,
        },
      ],
      list: [],
      getAll: false,
      endScreen: false,
    };
  },
  computed: {
    user_unique_code() {
      return this.$store.state.user_unique_code;
    },
    webInfo() {
      return this.$store.state.webInfo;
    },
  },
  watch: {
    webInfo(newVal) {
      if (newVal.service_code) {
        this.getFocusList();
      }
    },
  },
  created() {},
  methods: {
    routerPush(item) {
        console.log(item)
      const { href } = this.$router.resolve({
        name: "knowledgeLibDetail",
        params: {
          id: item.secondKnowledgeCode,
          subId: item.author_unique_code
        },
      });
      window.open(href, "_blank");
    },
    checkTab(index) {
      if (this.checkedTabIndex === index) {
        return;
      }
      this.checkedTabIndex = index;
      this.getAll = false;
      this.list = [];
      this.getFocusList();
    },
    loadMore() {
      const newPage = Math.ceil(this.list.length / 10) + 1;
      this.getFocusList(newPage);
    },
    async getFocusList(page = 1) {
      try {
        const { tabs, checkedTabIndex } = this;
        const { type } = tabs[checkedTabIndex];
        const data = await focusList({
          type,
          service_code: this.webInfo.service_code,
          page,
          pageSize: 10,
          user_unique_code: this.user_unique_code,
        });
        if (page !== 1) {
          this.list = this.list.concat(data);
          return;
        }
        if (data.length < 10) {
          this.getAll = true;
        }
        this.list = data;
      } catch (err) {
        if (err.code === "-1") {
          this.getAll = true;
        }
        console.log(err);
      }
    },
    itemClickHandler(item) {
      console.log(item);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { service_code } = vm.webInfo;
      if (service_code) {
        vm.getFocusList();
      }
    });
  },
};
</script>

<style scoped lang="less">
.focus-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.tabs-mask {
  width: 100%;
  box-sizing: border-box;
  padding: 30px 48px 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.tab-item {
  padding: 5px 10px;
  font-size: 15px;
  font-family: AlibabaPuHuiTiM;
  color: #909399;
  line-height: 24px;
  margin-right: 30px;
  cursor: pointer;
  user-select: none;

  &:last-child {
    margin-right: 0;
  }
}

.checked-tab {
  color: #303133;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
}

.main-content {
  width: 100%;
}

.action-warning-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 40px;

  .has-no-more {
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
    color: rgb(170, 169, 169);
    line-height: 40px;
    user-select: none;
  }
}

.list-mask {
  width: 100%;
  padding-bottom: 20px;
}

.result-list {
  width: 100%;
  box-sizing: border-box;
  padding: 0 48px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.magazine-item {
  width: 150px;
  margin-right: 24px;
  margin-bottom: 20px;

  .hb-resource-cover {
    width: 150px;
    height: 200px;
    border-radius: 4px;
  }

  p {
    width: 150px;
    font-size: 15px;
    font-family: AlibabaPuHuiTiM;
    color: #606266;
    line-height: 24px;
    margin-top: 10px;
  }
}

.article-item {
  width: 150px;
  height: 60px;
  box-sizing: border-box;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  margin-right: 20px;
  cursor: pointer;

  .hb-resource-cover {
    width: 40px;
    height: 40px;
    border-radius: 20px;
  }

  p {
    width: 80px;
    font-size: 15px;
    font-family: AlibabaPuHuiTiM;
    color: #606266;
    line-height: 24px;
    margin-left: 10px;
  }
}
</style>
